export const getCahorsData = () => ({
  name: "Cahors",
  region: "Sud-Ouest",
  country: "France",
  description: "Cahors est une appellation prestigieuse du Sud-Ouest de la France, célèbre pour ses vins rouges puissants et tanniques élaborés principalement à partir du cépage Malbec. Cette région produit des vins de garde exceptionnels avec une identité terroir marquée.",
  type: "subregion",
  area: "4,200 ha",
  production: "180,000 hectolitres",
  mapAreas: [
    { region: "Cahors", x: 1.4, y: 44.4, color: "#4B164C", size: 4 }
  ],
  characteristics: {
    climate: "Climat océanique avec influence méditerranéenne, étés chauds et secs, hivers doux",
    soil: "Sols très variés : calcaires, argiles, galets roulés, excellente diversité géologique",
    viticulture: "Viticulture traditionnelle, vendanges manuelles, rendements limités"
  },
  wineStyles: {
    red: "Vins rouges puissants et structurés, avec des tanins fermes et une excellente concentration",
    white: "Vins blancs secs et aromatiques, avec une belle acidité",
    rose: "Rosés fruités et équilibrés, parfaits pour l'apéritif"
  },
  history: "La viticulture à Cahors remonte à l'époque romaine. Au Moyen Âge, les vins de Cahors étaient très appréciés et exportés jusqu'en Angleterre. Le cépage Malbec (appelé Côt) est devenu le cépage emblématique de la région. Aujourd'hui, Cahors est reconnue pour ses vins de qualité et son identité terroir unique.",
  foodPairing: "Cuisine du Sud-Ouest, viandes rouges, gibier, fromages affinés, confit de canard, foie gras",
  grapeVarieties: [
    {
      name: "Malbec (Côt)",
      percentage: "70%",
      description: "Cépage emblématique de Cahors, produisant des vins puissants et tanniques",
      characteristics: "Puissant, tanins fermes, fruits noirs, épices",
      wineStyles: "Sec, plein-corps, complexe"
    },
    {
      name: "Merlot",
      percentage: "20%",
      description: "Cépage d'assemblage, apportant rondeur et fruité",
      characteristics: "Fruité, tanins doux, structure équilibrée",
      wineStyles: "Sec, moyen-corps, fruité"
    },
    {
      name: "Tannat",
      percentage: "10%",
      description: "Cépage local, apportant structure et tanins",
      characteristics: "Structuré, tanins fermes, notes de prune",
      wineStyles: "Sec, plein-corps, tannique"
    }
  ],
  subregions: {
    "cahors-central": {
      name: "Cahors Central",
      description: "Zone centrale de l'appellation, produisant les vins les plus prestigieux",
      characteristics: {
        climate: "Climat optimal, exposition sud",
        soil: "Sols calcaires et argileux",
        viticulture: "Viticulture traditionnelle"
      },
      grapeVarieties: {
        red: ["Malbec", "Merlot", "Tannat"]
      },
      wineStyles: {
        red: "Vins rouges de garde, complexes et structurés"
      },
      foodPairing: "Viandes rouges, gibier, fromages affinés"
    },
    "cahors-peripherique": {
      name: "Cahors Périphérique",
      description: "Zone périphérique, produisant des vins plus accessibles",
      characteristics: {
        climate: "Climat légèrement plus frais",
        soil: "Sols variés, moins calcaires",
        viticulture: "Viticulture moderne"
      },
      grapeVarieties: {
        red: ["Malbec", "Merlot"]
      },
      wineStyles: {
        red: "Vins rouges fruités et accessibles"
      },
      foodPairing: "Viandes blanches, charcuterie, fromages"
    }
  }
}); 